import type { DynamicLogEventPropertiesFunction } from '@/utils/logger-lib/logger.type';

export const getDynamicPropertiesFunction = (
  fn?: DynamicLogEventPropertiesFunction
): DynamicLogEventPropertiesFunction => {
  const dynamicPropertiesFn =
    fn instanceof Function
      ? fn
      : function () {
          return {};
        };

  return () => sanitizeDynamicData(dynamicPropertiesFn());
};

/**
 * Function sanitized unallowed properties from dynamic data
 * which are not allowed to be added / overriden in log event root.
 * Logger.type.ts contains type hint for unallowed keys, but this
 * will ensure runtime sanitization.
 */
const sanitizeDynamicData = (dynamicData: Record<string, string>): Record<string, string> => {
  const keysToOmit = [
    'opVersion',
    'timestamp',
    'application',
    'environment',
    'component',
    'logger',
    'severity',
    'message',
    'thread',
  ];
  const sanitizedData = Object.assign({}, dynamicData);

  Object.keys(sanitizedData).forEach((key) => {
    if (keysToOmit.includes(key)) {
      delete sanitizedData[key];
    }
  });

  return sanitizedData;
};
